import { identify, init } from "@dash0/sdk-web"
import type { Environment } from "@porsche-customer/slfinrtl-environment"
import { useEffect, useState } from "react"
import { getJwtPayload } from "src/common/jwt/jwtUtils"
import { scrubUrlAttributes } from "./scrubUrlAttributes"

const ignoreUrls: RegExp[] = []
const ignoreErrorMessages: RegExp[] = []

const tokenMap: Record<"preview" | "prod", string> = {
	preview: "auth_YJsQUAgO8XUwuB6t5dZEBuHVpsrnYlI8",
	prod: "auth_5ykPRVYhEFo3w4T6HP9IC8MgKHevoLQP",
}

export const useDash0 = (environment: Environment) => {
	const [isInitialized, setIsInitialized] = useState(false)
	useEffect(() => {
		function initializeDash0() {
			// Make sure the token is available and not the placeholder
			if (isInitialized || environment === "local" || environment === "dev") {
				return
			}
			const authToken = tokenMap[environment]

			init({
				endpoint: {
					authToken,
					url: "https://ingress.eu-west-1.aws.dash0.com",
				},
				environment,
				ignoreErrorMessages,
				ignoreUrls,
				serviceName: "cs-vehicle-dealer-app",
				serviceVersion: GIT_COMMIT_SHA,
				urlAttributeScrubber: scrubUrlAttributes,
			})

			const jwtPayload = getJwtPayload()
			if (jwtPayload) {
				identify(jwtPayload["ppn:userId"], { roles: jwtPayload["ppn:groups"].split(",") })
			}
			setIsInitialized(true)
		}

		void initializeDash0()
	}, [environment, isInitialized])
}
